import axios from 'axios';
import React, { Component } from 'react';

import spinner from '../images/spinner.svg';
import {
    Composition,
    Content,
    DesktopContainer,
    DesktopWrapper,
    Label,
    Mask,
    MaskFull,
    MaskSource,
    PhoneContainer,
    PhoneWrapper,
    Poster,
    PosterSource,
    Preloader,
    Section,
    TabletContainer,
    TabletWrapper,
    Text,
    Title,
    Video,
} from  './styled';

const SECTION_NAME = 'devices';

const PATHS = {
    mask_full_webp: '/static/images/catchup/devices-full.webp',
    mask_full_png: '/static/images/catchup/devices-full.png',
    mask_webp: '/static/images/catchup/devices.webp',
    mask_png: '/static/images/catchup/devices.png',
    poster_jpg: '/static/images/catchup/moana.jpg',
    poster_webp: '/static/images/catchup/moana.webp',
    mp4: '/static/video/catchup/catchup-devices.mp4',
    webm: '/static/video/catchup/catchup-devices.webm',
};

export default class SectionDevices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            isLoading: false,
            isPlaying: false,
        };

        this.phone = React.createRef();
        this.tablet = React.createRef();
        this.desktop = React.createRef();
    }

    isVideoExist() {
        return (this.phone.current !== null && this.tablet.current !== null && this.tablet.desktop !== null);
    }

    getVideoSrc() {
        return (this.phone.current.canPlayType('video/webm') !== '') ? PATHS.webm : PATHS.mp4;
    }

    playVideo() {
        if (this.props.breakpoint === 'tablet' || this.props.breakpoint === 'phone' || this.isIE()) {
 return;
}

        if (!this.state.isLoading && this.isVideoExist() && !this.state.isPlaying) {
            this.phone.current.currentTime = 0;
            this.tablet.current.currentTime = 0;
            this.desktop.current.currentTime = 0;
            this.phone.current.play();
            this.tablet.current.play();
            this.desktop.current.play();
            this.setState({ isPlaying: true });
        }
    }

    stopVideo() {
        if (!this.state.isLoading && this.isVideoExist() && this.state.isPlaying) {
            setTimeout(() => {
                this.phone.current.pause();
                this.tablet.current.pause();
                this.desktop.current.pause();
                this.setState({ isPlaying: false });
            }, 200);
        }
    }

    async loadVideo() {
        if (this.props.breakpoint === 'tablet' || this.props.breakpoint === 'phone') {
 return;
}
        if (this.state.isLoading) {
 return;
}

        const src = this.getVideoSrc();
        this.setState({ isLoading : true });

        try {
            const response = await axios.get(src, {
                responseType: 'blob',
            });

            const videoUrl = URL.createObjectURL(response.data);

            this.phone.current.src = videoUrl;
            this.tablet.current.src = videoUrl;
            this.desktop.current.src = videoUrl;

            this.setState({ isLoading : false, isLoaded: true });

            if (this.props.activeSlide.link === SECTION_NAME) {
                setTimeout(() => {
                    this.playVideo();
                }, 50);
            }
        } catch (e) {
            this.setState({ isLoading : false });
        }
    }

    isIE() {
        return (/MSIE|Trident|Edge/).test(window.navigator.userAgent);
    }

    componentDidMount() {
        if (this.isVideoExist() && !this.isIE()) {
            this.loadVideo();
        }
    }

    componentDidUpdate({ activeSlide, breakpoint }) {
        const isActive = (this.props.activeSlide.link === SECTION_NAME);

        if (breakpoint !== this.props.breakpoint) {
            if (this.props.breakpoint === 'tablet' || this.props.breakpoint === 'phone') {
 this.stopVideo();
} else if (!this.state.isLoaded) {
                    this.loadVideo();
                } else if (isActive) {
                    this.playVideo();
                }
        }

        if (activeSlide !== this.props.activeSlide) {
            if (!this.state.isLoaded && !this.isIE()) {
                this.loadVideo();
                return;
            }

            if (!isActive) {
                this.stopVideo();
            } else {
                this.playVideo();
            }
        }
    }

    render() {
        const { activeSlide, prevSlide, ...props } = this.props;

        const isActive = (activeSlide.link === SECTION_NAME);
        const from = (isActive) ? prevSlide.link : null;
        const to = (!isActive) ? activeSlide.link : null;

        return (
            <Section isActive={isActive} from={from} to={to} {...props}>
                <Content>
                    <Title>Управляйте просмотром на&nbsp;любом устройстве</Title>
                    <Text>Не успели досмотреть фильм дома на ТВ — поставьте его на паузу и продолжите со смартфона по дороге на работу.</Text>
                    <Text>Услуга работает на телевизорах с ТВ-приставкой, smart-телевизорах, планшетах, смартфонах, ноутбуках и домашних ПК.</Text>
                </Content>

                <Composition>
                    <TabletWrapper>
                        <TabletContainer>
                            <Video ref={this.tablet} muted={true} loop={true} />
                            <Poster isPlaying={this.state.isPlaying}>
                                <source srcSet={PATHS.poster_webp} type='image/webp' />
                                <PosterSource src={PATHS.poster_jpg} alt='Moana' />
                            </Poster>
                            {this.state.isLoading && (<Preloader src={spinner} alt='preloader' />)}
                        </TabletContainer>
                    </TabletWrapper>

                    <DesktopWrapper>
                        <DesktopContainer>
                            <Video ref={this.desktop} muted={true} loop={true} />
                            <Poster isPlaying={this.state.isPlaying}>
                                <source srcSet={PATHS.poster_webp} type='image/webp' />
                                <PosterSource src={PATHS.poster_jpg} alt='Moana' />
                            </Poster>
                            {this.state.isLoading && (<Preloader src={spinner} alt='preloader' />)}
                        </DesktopContainer>
                    </DesktopWrapper>

                    <PhoneWrapper>
                        <PhoneContainer>
                            <Video ref={this.phone} muted={true} loop={true} />
                            <Poster isPlaying={this.state.isPlaying}>
                                <source srcSet={PATHS.poster_webp} type='image/webp' />
                                <PosterSource src={PATHS.poster_jpg} alt='Moana' />
                            </Poster>
                            {this.state.isLoading && (<Preloader src={spinner} alt='preloader' />)}
                        </PhoneContainer>
                    </PhoneWrapper>


                    <Mask>
                        <source srcSet={PATHS.mask_webp} type='image/webp' />
                        <MaskSource draggable={false} src={PATHS.mask_png} alt='devices' />
                    </Mask>

                    <MaskFull>
                        <source srcSet={PATHS.mask_full_webp} type='image/webp' />
                        <MaskSource draggable={false} src={PATHS.mask_full_png} alt='devices' />
                    </MaskFull>
                </Composition>

                <Label>*На странице использован фрагмент из мультфильма «Моана»</Label>
            </Section>
        );
    }
}
